import React from "react";

const RepeatIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-arrow-repeat"
    viewBox="0 0 16 16"
  >
    <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
    <path
      fillRule="evenodd"
      d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
    />
  </svg>
);

export const DeleteIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-trash3"
    viewBox="0 0 16 16"
  >
    <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
  </svg>
);

export const ClipboardPlus = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-clipboard-plus"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 7a.5.5 0 0 1 .5.5V9H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V10H6a.5.5 0 0 1 0-1h1.5V7.5A.5.5 0 0 1 8 7z"
    />
    <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
    <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
  </svg>
);

export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-search"
    viewBox="0 0 16 16"
  >
    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
  </svg>
);

export const logoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    fill="currentColor"
    className="bi bi-box-arrow-left"
    viewBox="0 0 16 16"
    //   onClick={() => {
    //     localStorage.setItem("isLogged", false);
    //   }}
  >
    <path
      fillRule="evenodd"
      d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"
    />
    <path
      fillRule="evenodd"
      d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"
    />
  </svg>
);

export const InfoIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-info-lg"
    viewBox="0 0 16 16"
  >
    <path d="m9.708 6.075-3.024.379-.108.502.595.108c.387.093.464.232.38.619l-.975 4.577c-.255 1.183.14 1.74 1.067 1.74.72 0 1.554-.332 1.933-.789l.116-.549c-.263.232-.65.325-.905.325-.363 0-.494-.255-.402-.704l1.323-6.208Zm.091-2.755a1.32 1.32 0 1 1-2.64 0 1.32 1.32 0 0 1 2.64 0Z" />
  </svg>
);

export const InfoCircleIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-info-circle"
    viewBox="0 0 16 16"
  >
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
  </svg>
);

export const MedicalFileIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-clipboard2-pulse"
    viewBox="0 0 16 16"
  >
    <path d="M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5h3Z" />
    <path d="M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12Z" />
    <path d="M9.979 5.356a.5.5 0 0 0-.968.04L7.92 10.49l-.94-3.135a.5.5 0 0 0-.926-.08L4.69 10H4.5a.5.5 0 0 0 0 1H5a.5.5 0 0 0 .447-.276l.936-1.873 1.138 3.793a.5.5 0 0 0 .968-.04L9.58 7.51l.94 3.135A.5.5 0 0 0 11 11h.5a.5.5 0 0 0 0-1h-.128L9.979 5.356Z" />
  </svg>
);

export const BurgerIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-justify"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M2 12.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
    />
  </svg>
);

export const UndoIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-arrow-90deg-left"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M1.146 4.854a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H12.5A2.5 2.5 0 0 1 15 6.5v8a.5.5 0 0 1-1 0v-8A1.5 1.5 0 0 0 12.5 5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4z"
    />
  </svg>
);

export const CalindarIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-calendar-event"
    viewBox="0 0 16 16"
  >
    <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z" />
    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
  </svg>
);

export default RepeatIcon;

export const WhatsappIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-whatsapp"
    viewBox="0 0 16 16"
  >
    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
  </svg>
);

export const PhoneIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-telephone"
    viewBox="0 0 16 16"
  >
    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
  </svg>
);

export const GoogleIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-google"
    viewBox={`0 0 16 16`}
  >
    <path d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z" />
  </svg>
);

export const LogoutIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-box-arrow-in-right"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z"
    />
    <path
      fillRule="evenodd"
      d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
    />
  </svg>
);
export const PersonIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-person"
    viewBox="0 0 16 16"
  >
    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
  </svg>
);

export const PersonCircleIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-person-circle"
    viewBox="0 0 16 16"
  >
    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
    <path
      fillRule="evenodd"
      d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
    />
  </svg>
);

export const WifiIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-wifi"
    viewBox="0 0 16 16"
  >
    <path d="M15.384 6.115a.485.485 0 0 0-.047-.736A12.444 12.444 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.518.518 0 0 0 .668.05A11.448 11.448 0 0 1 8 4c2.507 0 4.827.802 6.716 2.164.205.148.49.13.668-.049z" />
    <path d="M13.229 8.271a.482.482 0 0 0-.063-.745A9.455 9.455 0 0 0 8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065A8.46 8.46 0 0 1 8 7a8.46 8.46 0 0 1 4.576 1.336c.206.132.48.108.653-.065zm-2.183 2.183c.226-.226.185-.605-.1-.75A6.473 6.473 0 0 0 8 9c-1.06 0-2.062.254-2.946.704-.285.145-.326.524-.1.75l.015.015c.16.16.407.19.611.09A5.478 5.478 0 0 1 8 10c.868 0 1.69.201 2.42.56.203.1.45.07.61-.091l.016-.015zM9.06 12.44c.196-.196.198-.52-.04-.66A1.99 1.99 0 0 0 8 11.5a1.99 1.99 0 0 0-1.02.28c-.238.14-.236.464-.04.66l.706.706a.5.5 0 0 0 .707 0l.707-.707z" />
  </svg>
);

export const WifiOffIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-wifi-off"
    viewBox="0 0 16 16"
  >
    <path d="M10.706 3.294A12.545 12.545 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.518.518 0 0 0 .668.05A11.448 11.448 0 0 1 8 4c.63 0 1.249.05 1.852.148l.854-.854zM8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065 8.448 8.448 0 0 1 3.51-1.27L8 6zm2.596 1.404.785-.785c.63.24 1.227.545 1.785.907a.482.482 0 0 1 .063.745.525.525 0 0 1-.652.065 8.462 8.462 0 0 0-1.98-.932zM8 10l.933-.933a6.455 6.455 0 0 1 2.013.637c.285.145.326.524.1.75l-.015.015a.532.532 0 0 1-.611.09A5.478 5.478 0 0 0 8 10zm4.905-4.905.747-.747c.59.3 1.153.645 1.685 1.03a.485.485 0 0 1 .047.737.518.518 0 0 1-.668.05 11.493 11.493 0 0 0-1.811-1.07zM9.02 11.78c.238.14.236.464.04.66l-.707.706a.5.5 0 0 1-.707 0l-.707-.707c-.195-.195-.197-.518.04-.66A1.99 1.99 0 0 1 8 11.5c.374 0 .723.102 1.021.28zm4.355-9.905a.53.53 0 0 1 .75.75l-10.75 10.75a.53.53 0 0 1-.75-.75l10.75-10.75z" />
  </svg>
);

export const HeartIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-heart"
    viewBox="0 0 16 16"
  >
    <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15" />
  </svg>
);

export const Heart_fillIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-heart-fill"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
    />
  </svg>
);

export const CheckCircleIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-check2-circle"
    viewBox="0 0 16 16"
  >
    <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" />
    <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
  </svg>
);

export const CircleIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    className="bi bi-circle"
    viewBox="0 0 16 16"
  >
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
  </svg>
);

export const CircleFilledIcon = (color, size) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 16}
    height={size ? size : 16}
    fill={color ? color : "currentColor"}
    class="bi bi-circle-fill"
    viewBox="0 0 16 16"
  >
    <circle cx="8" cy="8" r="8" />
  </svg>
);

export const AppStoreImage = (color, size) => (
  <svg
    id="OL"
    xmlns="http://www.w3.org/2000/svg"
    width="119.66408"
    height="40.00013"
    viewBox="0 0 119.66408 40.00013"
  >
    <title>Download_on_the_App_Store_Badge_AR_RGB_blk_102417</title>
    <g>
      <g>
        <path
          d="M9.53468,0c-.3667,0-.729,0-1.09473.002-.30615.002-.60986.00781-.919.0127A13.21479,13.21479,0,0,0,5.5171.19141a6.6651,6.6651,0,0,0-1.90088.627A6.43779,6.43779,0,0,0,1.99757,1.99707,6.25844,6.25844,0,0,0,.81935,3.61816a6.60119,6.60119,0,0,0-.625,1.90332,12.993,12.993,0,0,0-.1792,2.002C.00587,7.83008.00489,8.1377,0,8.44434V31.5586c.00489.3105.00587.6113.01515.9219a12.99234,12.99234,0,0,0,.1792,2.0019,6.58757,6.58757,0,0,0,.625,1.9043A6.20777,6.20777,0,0,0,1.99757,38.001a6.27446,6.27446,0,0,0,1.61865,1.1787,6.70087,6.70087,0,0,0,1.90088.6308,13.45487,13.45487,0,0,0,2.0039.1768c.30909.0068.6128.0107.919.0107C8.80567,40,9.168,40,9.53468,40H110.13477c.3594,0,.7246,0,1.084-.002.3047,0,.6172-.0039.9219-.0107a13.27905,13.27905,0,0,0,2-.1768,6.80427,6.80427,0,0,0,1.9082-.6308,6.27749,6.27749,0,0,0,1.6172-1.1787,6.39485,6.39485,0,0,0,1.1816-1.6143,6.60423,6.60423,0,0,0,.6191-1.9043,13.507,13.507,0,0,0,.1856-2.0019c.0039-.3106.0039-.6114.0039-.9219.0078-.3633.0078-.7246.0078-1.0938V9.53613c0-.36621,0-.72949-.0078-1.09179,0-.30664,0-.61426-.0039-.9209a13.50724,13.50724,0,0,0-.1856-2.002,6.61789,6.61789,0,0,0-.6191-1.90332,6.46615,6.46615,0,0,0-2.7988-2.7998,6.7676,6.7676,0,0,0-1.9082-.627,13.04391,13.04391,0,0,0-2-.17676c-.3047-.00488-.6172-.01074-.9219-.01269-.3594-.002-.7246-.002-1.084-.002h0"
          transform="translate(0 0.00013)"
          style={{ fill: "#a6a6a6" }}
        />
        <path
          d="M111.21387.875l.9131.0127a12.38493,12.38493,0,0,1,1.8584.16259,5.93833,5.93833,0,0,1,1.6709.54785,5.59375,5.59375,0,0,1,2.415,2.41993,5.76261,5.76261,0,0,1,.5352,1.64892,12.99507,12.99507,0,0,1,.1738,1.88721c.0029.2832.0029.5874.0029.89014.0079.375.0079.73193.0079,1.09179V30.4648c0,.3633,0,.7178-.0079,1.0752,0,.3252,0,.6231-.0039.9297a12.73188,12.73188,0,0,1-.1709,1.8535,5.739,5.739,0,0,1-.54,1.67,5.48036,5.48036,0,0,1-1.0156,1.3857,5.41292,5.41292,0,0,1-1.3994,1.0225,5.86168,5.86168,0,0,1-1.668.5498,12.54258,12.54258,0,0,1-1.8692.1631c-.2929.0068-.5996.0107-.8974.0107l-1.084.002L8.44483,39.125c-.30468,0-.602-.0039-.90429-.0107a12.6871,12.6871,0,0,1-1.86914-.1631,5.88383,5.88383,0,0,1-1.65674-.5479,5.40573,5.40573,0,0,1-1.397-1.0166,5.3208,5.3208,0,0,1-1.02051-1.3965,5.72186,5.72186,0,0,1-.543-1.6572,12.41352,12.41352,0,0,1-.1665-1.875C.88131,32.2471.873,31.5449.873,31.5449V8.44434S.88185,7.75293.8877,7.5498a12.3704,12.3704,0,0,1,.16553-1.87207,5.7555,5.7555,0,0,1,.54346-1.6621,5.37349,5.37349,0,0,1,1.01514-1.398A5.56543,5.56543,0,0,1,4.01417,1.59521a5.82309,5.82309,0,0,1,1.65332-.54394A12.58586,12.58586,0,0,1,7.543.88721L8.44532.875"
          transform="translate(0 0.00013)"
        />
      </g>
      <g id="_Group_" data-name=" Group ">
        <g id="_Group_2" data-name=" Group 2">
          <path
            id="_Path_"
            data-name=" Path "
            d="M107.259,20.30068a4.94881,4.94881,0,0,1,2.35656-4.15206,5.06566,5.06566,0,0,0-3.99116-2.15768c-1.67924-.17626-3.30719,1.00483-4.1629,1.00483-.87227,0-2.18977-.98733-3.6085-.95814a5.3153,5.3153,0,0,0-4.47292,2.72787c-1.934,3.34842-.49141,8.26947,1.3612,10.97608.9269,1.32535,2.01018,2.8058,3.42763,2.7533,1.38706-.05753,1.9051-.88448,3.5794-.88448,1.65876,0,2.14479.88448,3.591.8511,1.48838-.02416,2.42613-1.33124,3.32051-2.66914a10.96189,10.96189,0,0,0,1.51842-3.09251A4.78205,4.78205,0,0,1,107.259,20.30068Z"
            transform="translate(0 0.00013)"
            style={{ fill: "#fff" }}
          />
          <path
            id="_Path_2"
            data-name=" Path 2"
            d="M104.52739,12.21089a4.87248,4.87248,0,0,0,1.11452-3.49062,4.95746,4.95746,0,0,0-3.20758,1.65961,4.63635,4.63635,0,0,0-1.14371,3.36139A4.09905,4.09905,0,0,0,104.52739,12.21089Z"
            transform="translate(0 0.00013)"
            style={{ fill: "#fff" }}
          />
        </g>
      </g>
      <g>
        <path
          d="M17.1981,27.13965H12.4647L11.328,30.49609H9.3231l4.4834-12.418h2.083l4.4834,12.418H18.33383Zm-4.24316-1.54883h3.752l-1.84961-5.44727h-.05176Z"
          transform="translate(0 0.00013)"
          style={{ fill: "#fff" }}
        />
        <path
          d="M30.05552,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043V33.4912H21.5272V21.44238H23.326v1.50586h.03418A3.21162,3.21162,0,0,1,26.243,21.34766C28.54087,21.34766,30.05552,23.16406,30.05552,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459,1.44532,0,2.39259-1.19629,2.39259-3.0459Z"
          transform="translate(0 0.00013)"
          style={{ fill: "#fff" }}
        />
        <path
          d="M40.02037,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043V33.4912H31.492V21.44238h1.79883v1.50586H33.325a3.21162,3.21162,0,0,1,2.88281-1.60059C38.50572,21.34766,40.02037,23.16406,40.02037,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C37.16294,29.01563,38.11021,27.81934,38.11021,25.96973Z"
          transform="translate(0 0.00013)"
          style={{ fill: "#fff" }}
        />
        <path
          d="M46.6063,27.03613c.1377,1.23145,1.334,2.04,2.96875,2.04,1.56641,0,2.69336-.80859,2.69336-1.91895,0-.96387-.67969-1.541-2.28906-1.93652L48.37,24.833c-2.28027-.55078-3.33887-1.61719-3.33887-3.34766,0-2.14258,1.86719-3.61426,4.51855-3.61426,2.624,0,4.42285,1.47168,4.4834,3.61426h-1.876c-.1123-1.23926-1.13672-1.9873-2.63379-1.9873s-2.52148.75684-2.52148,1.8584c0,.87793.6543,1.39453,2.25488,1.79l1.36816.33594c2.54785.60254,3.60645,1.626,3.60645,3.44238,0,2.32324-1.85059,3.77832-4.79395,3.77832-2.75391,0-4.61328-1.4209-4.7334-3.667Z"
          transform="translate(0 0.00013)"
          style={{ fill: "#fff" }}
        />
        <path
          d="M58.242,19.2998v2.14258h1.72168v1.47168H58.242v4.99121c0,.77539.34473,1.13672,1.10156,1.13672a5.80743,5.80743,0,0,0,.61133-.043v1.46289a5.10345,5.10345,0,0,1-1.03223.08594c-1.833,0-2.54785-.68848-2.54785-2.44434V22.91406H55.05845V21.44238h1.31641V19.2998Z"
          transform="translate(0 0.00013)"
          style={{ fill: "#fff" }}
        />
        <path
          d="M60.96079,25.96973c0-2.84863,1.67773-4.63867,4.29395-4.63867,2.625,0,4.29492,1.79,4.29492,4.63867,0,2.85645-1.66113,4.63867-4.29492,4.63867C62.62193,30.6084,60.96079,28.82617,60.96079,25.96973Zm6.69531,0c0-1.9541-.89551-3.10742-2.40137-3.10742s-2.40039,1.16211-2.40039,3.10742c0,1.96191.89453,3.10645,2.40039,3.10645s2.40138-1.14454,2.40138-3.10645Z"
          transform="translate(0 0.00013)"
          style={{ fill: "#fff" }}
        />
        <path
          d="M71.08189,21.44238h1.77246v1.541h.043a2.1594,2.1594,0,0,1,2.17773-1.63574,2.86616,2.86616,0,0,1,.63672.06934v1.73828a2.59791,2.59791,0,0,0-.835-.1123,1.87263,1.87263,0,0,0-1.93652,2.083v5.37012h-1.8584Z"
          transform="translate(0 0.00013)"
          style={{ fill: "#fff" }}
        />
        <path
          d="M84.28013,27.83691c-.25,1.64355-1.85059,2.77148-3.89844,2.77148-2.63379,0-4.26855-1.76465-4.26855-4.5957,0-2.83984,1.64355-4.68164,4.19043-4.68164,2.50488,0,4.08008,1.7207,4.08008,4.46582v.63672H77.98912v.1123a2.358,2.358,0,0,0,2.43555,2.56445,2.04834,2.04834,0,0,0,2.09082-1.27344ZM77.9979,25.13477h4.52637a2.1773,2.1773,0,0,0-2.05288-2.295q-.08383-.00467-.16782-.00286a2.292,2.292,0,0,0-2.30563,2.27829Q77.99788,25.125,77.9979,25.13477Z"
          transform="translate(0 0.00013)"
          style={{ fill: "#fff" }}
        />
      </g>
      <g>
        <path
          d="M53.7939,16.0835h-.65332c-1.272,0-2.61377-.26123-2.61377-2.02148a9.81046,9.81046,0,0,1,.54-2.31738l.84521.22656-.12207.39209A7.92754,7.92754,0,0,0,51.433,14.062c0,1.21094,1.15869,1.21094,1.94287,1.21094h.54883c.39209,0,.93213-.15674.93213-.65332V11.17822h.93262v2.5791a1.53553,1.53553,0,0,0,.63574.12158h.32227v.80176h-.32227a2.26374,2.26374,0,0,1-.63574-.0957v.122C55.78951,15.15967,55.44088,16.0835,53.7939,16.0835Zm-.53125-5.84619a.56247.56247,0,1,1,.59229-.56641.55276.55276,0,0,1-.53748.56762q-.02742.00075-.05481-.00122Z"
          transform="translate(0 0.00013)"
          style={{ fill: "#fff" }}
        />
        <path
          d="M57.79976,13.87891a4.01977,4.01977,0,0,1-.14844-1.17627,1.86265,1.86265,0,0,1,1.89063-2.05615c1.2373,0,1.7168,1.01074,1.7168,2.21338,0,.88867-.314,2.09082-1.5249,2.09082a4.586,4.586,0,0,1-1.16748-.27h-1.978v-.80176Zm.94092.03516a2.81692,2.81692,0,0,0,.93213.21777c.54,0,.68848-.68848.68848-1.29834,0-.5835-.16553-1.41992-.87158-1.41992-.63574,0-.91455.59229-.91455,1.3418a3.41881,3.41881,0,0,0,.16552,1.15868Z"
          transform="translate(0 0.00013)"
          style={{ fill: "#fff" }}
        />
        <path
          d="M67.40767,16.0835h-.65332c-1.27246,0-2.61426-.26123-2.61426-2.02148a9.83461,9.83461,0,0,1,.54-2.31738l.8457.22656-.12207.39209A7.92511,7.92511,0,0,0,65.0463,14.062c0,1.21094,1.15918,1.21094,1.94336,1.21094h.54883c.3916,0,.93164-.15674.93164-.65332V8.80811h.93262v4.94922a1.53717,1.53717,0,0,0,.63574.12158h.32227v.80176h-.32227a2.26872,2.26872,0,0,1-.63574-.0957v.122C69.40279,15.15967,69.05416,16.0835,67.40767,16.0835Z"
          transform="translate(0 0.00013)"
          style={{ fill: "#fff" }}
        />
        <path
          d="M73.49556,10.69043v2.44824c0,1.03662-.61914,1.542-1.84766,1.542H70.20162v-.80176h1.41211c.74023,0,.94043-.32227.94043-.87109V10.69043Zm-2.335,5.94189a.56249.56249,0,1,1,.59277-.56641.55277.55277,0,0,1-.59274.56641Zm1.46387,0a.56246.56246,0,1,1,.5918-.56641.55276.55276,0,0,1-.53751.5676q-.02713.00074-.05424-.00119Z"
          transform="translate(0 0.00013)"
          style={{ fill: "#fff" }}
        />
        <path
          d="M74.19088,15.98779a3.48855,3.48855,0,0,0,.40039.02588c.76758,0,1.15039-.44434,1.15039-1.3418V11.16943h.94141V13.8789h.8623v.80176h-.87109a2.35047,2.35047,0,0,1-.60156,1.61182,2.215,2.215,0,0,1-1.51562.51416,5.18281,5.18281,0,0,1-.59277-.04346Zm1.97754-5.66357a.56249.56249,0,1,1,.59277-.56641.55247.55247,0,0,1-.59277.56641Z"
          transform="translate(0 0.00013)"
          style={{ fill: "#fff" }}
        />
        <path
          d="M80.63716,14.68066a2.34857,2.34857,0,0,1-1.07129-.29639,2.60147,2.60147,0,0,1-1.47266.29639h-.706V13.8789H78.146c.71387,0,.85352-.11328.85352-.63574V10.69043h.93262v3.03174a1.588,1.588,0,0,0,.70508.15674h.584v.80176ZM79.42623,9.81885a.56249.56249,0,1,1,.59277-.56641.55247.55247,0,0,1-.59277.56641Z"
          transform="translate(0 0.00013)"
          style={{ fill: "#fff" }}
        />
        <path
          d="M83.45064,10.69043v2.44824c0,1.03662-.61816,1.542-1.84668,1.542h-.541v-.80176h.50587c.74023,0,.94043-.32227.94043-.87109V10.69043ZM82.0649,9.81885a.56249.56249,0,1,1,.59277-.56641.55247.55247,0,0,1-.59277.56641Zm1.46387,0a.56249.56249,0,1,1,.59277-.56641.55247.55247,0,0,1-.59277.56641Z"
          transform="translate(0 0.00013)"
          style={{ fill: "#fff" }}
        />
      </g>
    </g>
  </svg>
);
